import React, { useEffect, useState } from 'react';
import { Tag } from 'primereact/tag';
import { monthNames } from '../../../utils/typeConstants';
import { useGetPrimaryApprovalWindowQuery } from '../../../pages/compensation/compensationSlice';
import { ApprovalLandingPageProps } from '../approvalLandingPage/ApprovalLandingPage';
import approvalNodata from '../../../assets/approvalNodata.png';

export const PayPeriodParticipantLandingPage = ({
    inputMonth,
    inputYear,
    scorecardVersionID,
}: ApprovalLandingPageProps) => {
    const [approvalWindowStatusPaused, setApprovalWindowStatusPaused] = useState<boolean>(false);
    const [approvalWindowStatusName, setApprovalWindowStatusName] = useState<string>('');

    const { data: primaryApprovalWindowData } = useGetPrimaryApprovalWindowQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: scorecardVersionID,
            approvalWindowConfigLevelId: 3,
        },
        { skip: !inputYear || !inputMonth }
    );

    useEffect(() => {
        if (primaryApprovalWindowData?.data?.length > 0) {
            setApprovalWindowStatusName(primaryApprovalWindowData?.data[0]?.approval_window_status_name);
            setApprovalWindowStatusPaused(primaryApprovalWindowData?.data[0]?.approvals_paused);
        }
    }, [primaryApprovalWindowData]);

    return (
        <div style={{ width: '100%' }}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'nowrap', marginBottom: '0.5rem' }}>
                <h6 className="card-title mb-0" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                    <b>Pay Period : {monthNames[inputMonth ?? 0]} {inputYear}</b>
                </h6>
                {primaryApprovalWindowData?.data?.length > 0 && (
                    <span style={{ flexShrink: 0 }}>
                        {approvalWindowStatusPaused ? (
                            <Tag
                                className="mr-2"
                                icon="pi pi-times"
                                severity="danger"
                                value={approvalWindowStatusName + ' (Stalled)'}
                                rounded
                            />
                        ) : (
                            <Tag
                                className="mr-2"
                                icon="pi pi-info-circle"
                                severity="info"
                                value={approvalWindowStatusName}
                                rounded
                            />
                        )}
                    </span>
                )}
            </div>
            {primaryApprovalWindowData?.data?.length === 0 ? (
                <div className="no-data-wrapper">
                    <div className="no-data-inner">
                        <img src={approvalNodata} alt="No Data" style={{ maxWidth: '70%' }} />
                    </div>
                </div>
            ) : (
                <div>
                    <hr className="mt-2" />
                    {/* tableLayout fixed + equal thirds ensures labels, Open Date and Close Date
                        each occupy exactly 1/3 of the full card width — matching Figma layout */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem', tableLayout: 'fixed' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '33%', padding: '6px 6px 6px 1rem', textAlign: 'left' }} />
                                <th style={{ width: '33%', padding: '6px', fontWeight: 700, fontStyle: 'bold', textAlign: 'center' }}>Open Date</th>
                                <th style={{ width: '34%', padding: '6px', fontWeight: 700, fontStyle: 'bold', textAlign: 'center' }}>Close Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '8px 6px 8px 5rem', whiteSpace: 'nowrap', fontWeight: 700, fontStyle: 'bold' }}>Associate</td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.associate_start_date
                                        ? new Date(primaryApprovalWindowData.data[0].associate_start_date).toLocaleDateString()
                                        : '--'}
                                </td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.associate_end_date
                                        ? new Date(primaryApprovalWindowData.data[0].associate_end_date).toLocaleDateString()
                                        : '--'}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: '8px 6px 8px 5rem', whiteSpace: 'nowrap', fontWeight: 700, fontStyle: 'bold' }}>Team Lead</td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.team_lead_start_date
                                        ? new Date(primaryApprovalWindowData.data[0].team_lead_start_date).toLocaleDateString()
                                        : '--'}
                                </td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.team_lead_end_date
                                        ? new Date(primaryApprovalWindowData.data[0].team_lead_end_date).toLocaleDateString()
                                        : '--'}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ padding: '8px 6px 8px 5rem', whiteSpace: 'nowrap', fontWeight: 700, fontStyle: 'bold' }}>Manager</td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.manager_start_date
                                        ? new Date(primaryApprovalWindowData.data[0].manager_start_date).toLocaleDateString()
                                        : '--'}
                                </td>
                                <td style={{ padding: '8px 6px', textAlign: 'center', fontWeight: 400 }}>
                                    {primaryApprovalWindowData?.data[0]?.manager_end_date
                                        ? new Date(primaryApprovalWindowData.data[0].manager_end_date).toLocaleDateString()
                                        : '--'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
